export const CASINO_TAB = {
    KASINO: 'KASINO',
    HRY: 'HRY',
    LOBBY: 'LOBBY',
    SCRATCH: 'SCRATCH'
} as const;

export type CasinoTab = typeof CASINO_TAB[keyof typeof CASINO_TAB];

export const ALL_GAMES = 'all-games';
export const ALL_GAMES_SLUG = 'casino-hry';

export const PAYMENT_SOURCE = {
    MENU: 'MENU',
    NOTIFICATION: 'NOTIFICATION'
} as const;

export enum reactQueryKey {
    casinoJackpots = 'casino-jackpots',
    casinoStories = 'casino-stories',
    casinoGameSiblings = 'casino-game-siblings',
    casinoGamebook = 'casino-gamebook',
    casinoIScratchEmissionList = 'casino-iScratch-emission-list'
}
